module.exports = __webpack_public_path__ + "static/banner-a6999c227de0b893b06bea25b497f52c.png";